export default function Footer() {
  const scrollToSection = (id) => (e) => {
    e.preventDefault();
    const el = document.getElementById(id);
    if (!el) return;
    el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <footer className="mt-24">
      <div className="w-full bg-[color:var(--bg2)]">
        <div className="mx-auto max-w-6xl px-6 py-14">
          <div className="flex flex-col items-center gap-6 text-center">
            <div className="flex items-center gap-3">
              <div className="flex h-11 w-11 items-center justify-center overflow-hidden rounded-xl bg-white">
                <img
                  src="/img/Logobelskin1.png"
                  alt="BELSKIN NURSE"
                  className="h-full w-full object-contain"
                />
              </div>

              <span className="text-lg font-semibold tracking-tight">
                BELSKIN NURSE
              </span>
            </div>

            <nav className="flex flex-wrap justify-center gap-6 text-sm text-[color:var(--muted)]">
              <a
                href="#features"
                onClick={scrollToSection("features")}
                className="transition hover:text-[color:var(--ink)]"
              >
                Tratamientos
              </a>

              <a
                href="#nosotros"
                onClick={scrollToSection("nosotros")}
                className="transition hover:text-[color:var(--ink)]"
              >
                Especialista
              </a>

              <a
                href="#contact"
                onClick={scrollToSection("contact")}
                className="transition hover:text-[color:var(--ink)]"
              >
                Contacto
              </a>
            </nav>
          </div>

          <div className="my-10 h-px w-full bg-[color:var(--border)]" />

          <div className="flex flex-col items-center justify-between gap-4 text-sm text-[color:var(--muted)] md:flex-row">
            <p>
              © {new Date().getFullYear()} Clínica BELSKIN NURSE. Todos los
              derechos reservados.
            </p>

            <a
              href="https://zentragroup.cl"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 rounded-full border border-[color:var(--border)] bg-white/70 px-4 py-2 transition hover:bg-white"
            >
              <span className="text-[color:var(--muted)]">
                Desarrollado por
              </span>

              <span
                className="
                  font-semibold
                  bg-gradient-to-r
                  from-[#204B97]
                  via-[#36C0B9]
                  to-[#204B97]
                  bg-clip-text text-transparent
                "
              >
                Zentra Group
              </span>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}